import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export interface TabItem<V extends string = string> {
  value: V;
  label: ReactNode;
  count?: number;
  icon?: ReactNode;
}

/** Pill-tablar (bo'limlar, filtr holatlari, "1K 1H 1O 6O 1Y"). */
export function Tabs<V extends string>({
  items,
  value,
  onChange,
  size = 'md',
  className,
  ariaLabel,
}: {
  items: TabItem<V>[];
  value: V;
  onChange: (v: V) => void;
  size?: 'sm' | 'md';
  className?: string;
  ariaLabel?: string;
}) {
  return (
    <div className={clsx('kts-tabs', size === 'sm' && 'kts-tabs--sm', className)} role="tablist" aria-label={ariaLabel}>
      {items.map((it) => (
        <button
          key={it.value}
          type="button"
          role="tab"
          aria-selected={it.value === value}
          className="kts-tab"
          onClick={() => onChange(it.value)}
        >
          {it.icon}
          {it.label}
          {it.count !== undefined && it.count > 0 && <span className="kts-tab__count">{it.count > 999 ? '999+' : it.count}</span>}
        </button>
      ))}
    </div>
  );
}

/** Filtr chiplari (bir nechtasini tanlash mumkin). */
export function ChipGroup<V extends string>({
  items,
  value,
  onChange,
}: {
  items: { value: V; label: ReactNode }[];
  value: V[];
  onChange: (v: V[]) => void;
}) {
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {items.map((it) => {
        const on = value.includes(it.value);
        return (
          <button
            key={it.value}
            type="button"
            className="kts-chip"
            aria-pressed={on}
            onClick={() => onChange(on ? value.filter((v) => v !== it.value) : [...value, it.value])}
          >
            {it.label}
          </button>
        );
      })}
    </div>
  );
}
